// src/components/Header.js
/* global dataLayer */ // Add this to avoid the ESLint error
import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import '../css/Header.css'; // Import a custom CSS file for styling
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/custom.css'; // Import your custom CSS

const Header = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showServices, setShowServices] = useState(false);

    const location = useLocation();
    const isMobile = window.innerWidth < 992;

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        const navbar = document.getElementById('main-nav');
        if (navbar) {
            if (isExpanded) {
                navbar.classList.remove('on-bottom');
            } else {
                navbar.classList.add('on-bottom');
            }
        }
    }, [isExpanded]);

    useEffect(() => {
        // Add Google Analytics script dynamically
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=G-JJH2JKYY7J`;
        document.head.appendChild(script);

        script.onload = () => {
            // Initialize Google Analytics
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-JJH2JKYY7J');
        };

        // Cleanup the script when the component unmounts
        return () => {
            document.head.removeChild(script);
        };
    }, []);

    useEffect(() => {
        // Track pageview whenever the location changes
        if (window.gtag) {
            window.gtag('config', 'G-JJH2JKYY7J', {
                page_path: location.pathname + location.search
            });
        }
    }, [location]);

    return (
        <>
            <div className="header-main-container">
                <div className="header-navbar-container" style={{ width: '100%', justifyContent: 'end', display: 'flex' }}>
                    <div className="header-logo-container" style={{ justifyContent: 'start', width: '100%' }}>
                        <a href='/'>
                            <img className='header-logo' src="/logo_main.png" alt="Logo" style={{ height: '110px' }} /> {/* Adjust height as needed */}
                        </a>
                    </div>
                    <Navbar id="main-nav" className="nav-menu-position" bg="light" expand="lg" expanded={isExpanded}>
                        <Container fluid>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav
                                    className="navbar-menu-items"
                                    style={{
                                        width: '100%',
                                        justifyContent: 'start',
                                        display: 'flex',
                                        flexDirection: window.innerWidth <= 1024 ? 'column' : 'row', // Treat tablets like mobile
                                        alignItems: window.innerWidth > 1024 ? 'center' : 'flex-start',
                                        margin: '30px 30px',
                                        gap: '20px',
                                    }}
                                >
                                    <Nav.Link as={NavLink} to="/" end onClick={() => setIsExpanded(false)}>
                                        HOME
                                    </Nav.Link>
                                    <NavDropdown
                                        title={
                                            isMobile ? (
                                                <span className="nav-link" style={{ cursor: 'pointer' }}>SERVICES</span>
                                            ) : (
                                                <NavLink to="/services" className="nav-link">SERVICES</NavLink>
                                            )
                                        }
                                        id="services-dropdown"
                                        {...(!isMobile && { show: showServices })} // Only set show on desktop
                                        onMouseEnter={!isMobile ? () => setShowServices(true) : undefined}
                                        onMouseLeave={!isMobile ? () => setShowServices(false) : undefined}
                                        onClick={isMobile ? (e) => { e.preventDefault(); setShowServices(!showServices); } : undefined}
                                    >
                                        {/** */}
                                        <NavDropdown.Item as={NavLink} to="/services/free-home-delivery" onClick={() => setIsExpanded(false)}>
                                            Free Home Delivery
                                        </NavDropdown.Item>
                                        {/**<NavDropdown.Item as={NavLink} to="/services/health-products" onClick={() => setIsExpanded(false)}>
                                                Health Products
                                            </NavDropdown.Item>
                                             */}
                                        <NavDropdown.Item as={NavLink} to="/services/refill-made-easy" onClick={() => setIsExpanded(false)}>
                                            Refills Made Easy
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={NavLink} to="/services/prescription-fulfillment" onClick={() => setIsExpanded(false)}>
                                            Prescription Fulfillment
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={NavLink} to="/services/over-the-counter-medications" onClick={() => setIsExpanded(false)}>
                                            OTC Medications & Essentials
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={NavLink} to="/services/Vaccinations" onClick={() => setIsExpanded(false)}>
                                            Vaccinations
                                        </NavDropdown.Item>

                                    </NavDropdown>
                                    {/* <Nav.Link as={NavLink} to="/refills" onClick={() => setIsExpanded(false)}>
                                        REFILLS
                                    </Nav.Link>
                                    <Nav.Link as={NavLink} to="/transfer" onClick={() => setIsExpanded(false)}>
                                        TRANSFER
                                    </Nav.Link>
                                    * */}
                                    <Nav.Link as={NavLink} to="/about" onClick={() => setIsExpanded(false)}>
                                        ABOUT&nbsp;US
                                    </Nav.Link>

                                    <Nav.Link
                                        as={NavLink}
                                        to="/contact"
                                        style={{
                                            backgroundColor: '#003366',
                                            color: 'white',
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            textAlign: 'center',
                                            transition: 'background-color 0.3s ease', // Smooth transition for hover effect
                                        }}
                                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#268fc9')} // Light red shade on hover
                                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#003366')} // Reset to original color
                                        onClick={() => setIsExpanded(false)}
                                    >
                                        CONTACT&nbsp;US
                                    </Nav.Link>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </div>
            </div>
        </>
    );
};

export default Header;